import { QueryClient } from "@tanstack/react-query"
import { AxiosError } from "axios"

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      networkMode: import.meta.env.DEV ? "always" : "online",
      retry: (failureCount, error) => {
        if (failureCount > 3) return false
        if (error instanceof AxiosError) {
          // Do not retry on authorization errors
          return ![401, 403].includes(error.response?.status ?? 0)
        }
        return true
      },
    },
    mutations: {
      networkMode: import.meta.env.DEV ? "always" : "online",
    },
  },
})
